export default "__VITE_ASSET__CySVSa0Z__"